import { inject, ref, watch } from 'vue';
import { debounce } from 'lodash';
import { IKPageSize } from '@/types/injectionKeys';

export const useKeyGenRerender = (prefix = '', timeout = 300) => {
  const keyIndex = ref(0);
  const key = ref(`${prefix}${keyIndex.value}`);

  const size = inject(IKPageSize);

  const updateKey = debounce(() => {
    keyIndex.value++;
    key.value = `${prefix}${keyIndex.value}`;
  }, timeout);

  watch(() => size?.value.width, updateKey);

  return key;
};
